import React, { useState } from "react";
import { FileDownload, ListAlt } from "@mui/icons-material";

import BomModal from "fond/project/bom/BomModal";
import { Project } from "fond/types";
import { StackedNavigationButton, useStackedNavigationContext } from "fond/widgets";

interface DesignArtifactsPanelProps {
  project: Project;
}

const DesignArtifactsPanel: React.FC<DesignArtifactsPanelProps> = ({ project }) => {
  const { open } = useStackedNavigationContext();
  const [isBomModalOpen, setIsBomModalOpen] = useState(false);

  return (
    <>
      <StackedNavigationButton
        data-testid="view-bill-of-materials-button"
        icon={<ListAlt />}
        title="Bill of materials"
        subtitle="View design bill of materials"
        sx={{ m: 0 }}
        onClick={() => setIsBomModalOpen(true)}
      />
      <StackedNavigationButton
        data-testid="export-construction-prints-button"
        icon={<FileDownload />}
        title="Construction prints"
        subtitle="Export construction prints"
        sx={{ m: 0, mt: 1 }}
        onClick={() => open("mu-construction-prints-export")}
      />
      {isBomModalOpen && <BomModal project={project} architecture={null} onClose={() => setIsBomModalOpen(false)} />}
    </>
  );
};

export default DesignArtifactsPanel;
